import React from "react";

export default function MqlComponent() {
  return (
    <div className="about_area pt-45 pb-10">
      <div className="container">
        <div className="row">
          

          {/* Text Content Section */}
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-6">
            <div className="section_title text_left mb-40 mt-3">
              
              <div className="section_main_title text-left">
                <h1>Maximize Engagement with  
              
                <span> Marketing Qualified Leads</span>
                </h1>
              </div>
              <div className="em_bar">
                <div className="em_bar_bg"></div>
              </div>
             
            </div>

            <div className="singel_about_left mb-30">
              <div className="singel_about_left_inner mb-3">
                <div className="singel-about-content text-left">
                
                  <p>
                  Marketing Qualified Leads (MQL) connects businesses directly with decision-makers who show clear interest in tailored solutions or services. This refined approach removes uncertainty, sharpening the focus of outbound strategies by targeting only those prospects ready for meaningful interaction.
                  </p>
                  <p>
                  Built on a data-driven, multi-touch framework and enriched with advanced behavioral insights, this solution accelerates pipeline development, boosts conversion rates, and enhances ROI. Every relevant lead is meticulously sourced through a voice-verified process, blending strategic outreach with rigorous analytical validation to leads of unmatched relevance and engagement potential.

                  </p>
                </div>
              </div>

              
            </div>
          </div>
          {/* Image Section */}
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-6">
            <div className="about_thumb mql">
              <img src="/assets/images/marketing-qualified-leads.webp" alt="marketing qualified leads" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
